/** 极鲸云跨境选品与数据分析（选品洞察 / Listing 文案统一入口） */
export const GEEKBI_HOT_SALE_URL = 'https://www.geekbi.com/shein/goods/hot-sale';

export function openGeekbiHotSale() {
  window.open(GEEKBI_HOT_SALE_URL, '_blank', 'noopener,noreferrer');
}
